var map = {
	"./afghanistan.svg": "55ae",
	"./albania.svg": "647a",
	"./algeria.svg": "4ca9",
	"./andorra.svg": "3b6b",
	"./angola.svg": "ab18",
	"./antigua-and-barbuda.svg": "9606",
	"./argentina.svg": "04a4",
	"./armenia.svg": "e992",
	"./aruba.svg": "ef9e",
	"./australia.svg": "daa7",
	"./austria.svg": "c8cd",
	"./azerbaijan.svg": "803a",
	"./bahamas.svg": "8bd4",
	"./bahrain.svg": "1cd7",
	"./bangladesh.svg": "4746",
	"./barbados.svg": "3050",
	"./belarus.svg": "1927",
	"./belgium.svg": "e9af",
	"./belize.svg": "555b",
	"./benin.svg": "30b3",
	"./bhutan.svg": "a6b1",
	"./bolivia.svg": "d20a",
	"./bosnia-and-herzegovina.svg": "3432",
	"./botswana.svg": "f0aa",
	"./bouvet-island.svg": "cd4b",
	"./brazil.svg": "fcc5",
	"./brunei-darussalam.svg": "7a7f",
	"./bulgaria.svg": "a7b5",
	"./burkina-faso.svg": "59ca",
	"./burundi.svg": "403b",
	"./cambodia.svg": "6c3f",
	"./cameroon.svg": "3c39",
	"./canada.svg": "c8f7",
	"./cape-verde.svg": "1d77",
	"./central-african-republic.svg": "0354",
	"./chad.svg": "78c2",
	"./chile.svg": "e7a6",
	"./china.svg": "7334",
	"./colombia.svg": "6fff",
	"./comoros.svg": "f1d5",
	"./congo.svg": "88e1",
	"./costa-rica.svg": "c865",
	"./croatia.svg": "076b",
	"./cuba.svg": "708c",
	"./cura-ao.svg": "ad7c",
	"./cyprus.svg": "47a5",
	"./czech-republic.svg": "37e4",
	"./denmark.svg": "6547",
	"./djibouti.svg": "7123",
	"./dominica.svg": "7499",
	"./dominican-republic.svg": "f19c",
	"./dr-congo.svg": "5ce8",
	"./ecuador.svg": "ac6a",
	"./egypt.svg": "da4b",
	"./el-salvador.svg": "36e9",
	"./equatorial-guinea.svg": "3959",
	"./eritrea.svg": "dc64",
	"./estonia.svg": "86f8",
	"./eswatini.svg": "b713",
	"./ethiopia.svg": "ef4b",
	"./europe.svg": "82e0",
	"./fiji.svg": "fe26",
	"./finland.svg": "0012",
	"./france.svg": "2f1e",
	"./gabon.svg": "39cc",
	"./gambia.svg": "de0f",
	"./georgia.svg": "5392",
	"./germany.svg": "3387",
	"./ghana.svg": "7063",
	"./greece.svg": "a6bc",
	"./grenada.svg": "aa75",
	"./guatemala.svg": "9e69",
	"./guinea-bissau.svg": "702e",
	"./guinea.svg": "36ab",
	"./guyana.svg": "ad92",
	"./haiti.svg": "bfd5",
	"./holy-see.svg": "6a34",
	"./honduras.svg": "79e6",
	"./hong-kong.svg": "7419",
	"./hungary.svg": "51e5",
	"./iceland.svg": "ac73",
	"./india.svg": "6d44",
	"./indonesia.svg": "143d",
	"./iran.svg": "8245",
	"./iraq.svg": "e41b",
	"./ireland.svg": "6800",
	"./israel.svg": "859e",
	"./italy.svg": "4a35",
	"./ivory-coast.svg": "72e6",
	"./jamaica.svg": "d21e",
	"./japan.svg": "7ce6",
	"./jordan.svg": "bf30",
	"./kazakhstan.svg": "4da0",
	"./kenya.svg": "958d",
	"./kiribati.svg": "82bd",
	"./korea.svg": "2799",
	"./kuwait.svg": "bbae",
	"./kyrgyzstan.svg": "f02e",
	"./laos.svg": "f027",
	"./latvia.svg": "e742",
	"./lebanon.svg": "d2de",
	"./lesotho.svg": "77c4",
	"./liberia.svg": "1022",
	"./libya.svg": "cbdf",
	"./liechtenstein.svg": "aaa0",
	"./lithuania.svg": "e7cf",
	"./luxembourg.svg": "eba3",
	"./madagascar.svg": "0b18",
	"./malawi.svg": "d623",
	"./malaysia.svg": "d006",
	"./maldives.svg": "2dcf",
	"./mali.svg": "742f",
	"./malta.svg": "398f",
	"./marshall-islands.svg": "301f",
	"./mauritania.svg": "5e1d",
	"./mauritius.svg": "201a",
	"./mexico.svg": "a5fb",
	"./micronesia.svg": "9b3d",
	"./moldova.svg": "8703",
	"./monaco.svg": "b328",
	"./mongolia.svg": "49ed",
	"./montenegro.svg": "67e9",
	"./morocco.svg": "2f2c3",
	"./mozambique.svg": "fb22",
	"./myanmar.svg": "1ff7",
	"./namibia.svg": "2015",
	"./nauru.svg": "bde6",
	"./nepal.svg": "784e",
	"./netherlands.svg": "affc",
	"./new-zealand.svg": "b246",
	"./nicaragua.svg": "ef02",
	"./niger.svg": "17f7",
	"./nigeria.svg": "a75e",
	"./north-korea.svg": "54fa",
	"./north-macedonia.svg": "cdb5",
	"./norway.svg": "567a",
	"./oman.svg": "d306",
	"./pakistan.svg": "d690",
	"./palau.svg": "2934",
	"./palestine.svg": "5811",
	"./panama.svg": "d056",
	"./papua-new-guinea.svg": "ff36",
	"./paraguay.svg": "a46f",
	"./peru.svg": "b209",
	"./philippines.svg": "e8ca",
	"./poland.svg": "f0fa",
	"./portugal.svg": "7a88",
	"./qatar.svg": "6776",
	"./romania.svg": "f519",
	"./russia.svg": "9eb7",
	"./rwanda.svg": "d09a",
	"./saint-lucia.svg": "a0f1",
	"./saint-vicent-and-the-grenadines.svg": "00a2",
	"./samoa.svg": "838a",
	"./san-marino.svg": "2027",
	"./sao-tome-and-principe.svg": "372e",
	"./saudi-arabia.svg": "6e48",
	"./senegal.svg": "139b",
	"./serbia.svg": "2636",
	"./seychelles.svg": "5280",
	"./sierra-leone.svg": "ac94",
	"./singapore.svg": "4a77",
	"./sint-maarten.svg": "1ade",
	"./slovakia.svg": "2335",
	"./slovenia.svg": "d523",
	"./solomon-islands.svg": "b1e0",
	"./somalia.svg": "0e34",
	"./south-africa.svg": "6a6f",
	"./south-sudan.svg": "74d6",
	"./spain.svg": "ee4d",
	"./sri-lanka.svg": "bfa2",
	"./sudan.svg": "dd72",
	"./suriname.svg": "a4b6",
	"./sweden.svg": "5708",
	"./switzerland.svg": "61b9",
	"./syria.svg": "4295",
	"./taiwan.svg": "456e",
	"./tajikistan.svg": "0b8d",
	"./tanzania.svg": "8cee",
	"./thailand.svg": "e3f4",
	"./timor-leste.svg": "2905",
	"./togo.svg": "c871",
	"./tonga.svg": "d003",
	"./trinidad-and-tobago.svg": "efc6",
	"./tunisia.svg": "27ea",
	"./turkey.svg": "1f4e",
	"./turkmenistan.svg": "52c0",
	"./tuvalu.svg": "5d03",
	"./uganda.svg": "fd85",
	"./ukraine.svg": "ce65",
	"./united-arab-emirates.svg": "7c8b",
	"./united-kingdom.svg": "1d7b",
	"./united-states-of-america.svg": "432f",
	"./uruguay.svg": "1b48",
	"./uzbekistan.svg": "b5a7",
	"./vanuaty.svg": "637a",
	"./venezuela.svg": "ef38",
	"./vietnam.svg": "c802",
	"./virgin-islands.svg": "0122",
	"./yemen.svg": "6d09",
	"./zambia.svg": "ecd0",
	"./zimbabwe.svg": "48f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e83";